<script>
export default {
    name: "DiagnosisTab",

    props: {
        diagnosis: Array,
        encounters: Array,
    },

    methods: {

        printMedicalFile() {
            window.print();
        },
    }
}
</script>
<template>
    <div class="w-full flex-wrap">
        <div class="w-full p-1 hide--print">
            <span class="py-px px-3 font-medium bg-blue-800 text-white rounded text-xs mr-2">Inpatient</span>
            <span class="py-px px-3 font-medium bg-blue-400 text-white rounded text-xs mr-2">Outpatient</span>
            <span class="py-px px-3 font-medium bg-yellow-500 text-white rounded text-xs mr-2">Triage</span>
            <span class="py-px px-3 font-medium bg-green-500 text-white rounded text-xs mr-2">Discharge</span>
        </div>
        <div class="w-full" v-for="encounter in encounters" :key="encounter.encounterId">
            <div class="w-full p-1 rounded-t-md"
                :class="{
                    'bg-blue-400': encounter.category == `OutPatient`,
                    'bg-blue-800' : encounter.category == `InPatient`,
                    'bg-yellow-500' : encounter.category == `Triage`,
                }"
                v-if="diagnosis.length && 
                    diagnosis.filter(diag => encounter.encounterId==diag.encounterId).length">
                <h5 class="font-bold text-white text-sm">
                    Encounter #{{ encounter.encounterId }} Visit #{{encounter.visitNo}}</h5>
            </div>
            <div class="w-full p-1 flex flex-wrap bg-gray-200 my-1 text-sm" v-for="diag in 
                diagnosis.filter(diag => encounter.encounterId==diag.encounterId)" 
                :key="diag.diagnosisId">
                <div class="md:w-1/3 w-1/2 p-1">
                    <h5 class="font-medium">
                        <span>Diagnosis: </span><span class="break-words">{{ diag.disease }}</span></h5>
                </div>
                <div class="md:w-1/3 w-1/2 p-1">
                    <h5 class="font-medium">
                        <span>Stage: </span><span>{{ diag.stage }}</span></h5>
                </div>
                <div class="md:w-1/3 w-1/2 p-1">
                    <h5 class="font-medium">
                        <span>Date: </span><span>{{ diag.txnDate | dateFormat }}</span></h5>
                </div>
            </div>
        </div>
        <div class="w-full p-1 text-right">
            <button 
                @click.prevent="printMedicalFile"
                class="btn-sm btn-primary text-xs hide--print">
                    <i class="fa fa-print"></i> Print</button>
        </div>
    </div>
</template>
<style scoped>
    @media print {
        .hide--print {
            display: none;
        }
    }
</style>
